if (!customElements.get('split-text')) {
  customElements.define('split-text', class SplitText extends HTMLElement {
    constructor() {
      super();
      this._text = '';
    }

    connectedCallback() {
      if (this.hasAttribute('data-split-ready')) return;

      this._text = this.textContent.trim();
      this.setAttribute('data-split-ready', '');

      this.split();
    }

    disconnectedCallback() {
      this.restore();
    }

    restore() {
      this.textContent = this._text;
      this.removeAttribute('data-split-ready');
    }

    split() {
      const nodes = Array.from(this.childNodes);
      this.innerHTML = '';
      let charIndex = 0;
      let currentWord = null;

      nodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          this.appendChild(node);
          return;
        }
                
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          const words = text.split(/\s+/);

          words.forEach((word, wordIndex) => {
            if (!word) return;

            currentWord = document.createElement('span');
            currentWord.className = 'word-wrapper';

            [...word].forEach(char => {
              const span = document.createElement('span');
              span.className = 'split-char';
              span.textContent = char;
              span.style.setProperty('--i', charIndex);
              charIndex++;

              currentWord.appendChild(span);
            });

            this.appendChild(currentWord);

            if (wordIndex < words.length - 1) {
              const space = document.createTextNode(' ');
              this.appendChild(space);
            }
          });
        }
      });
    }
  });
}